const trimTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');

const appEnv = import.meta.env.VITE_APP_ENV || import.meta.env.MODE || 'development';

export const env = {
  appEnv,
  isDevelopment: appEnv === 'development',
  isStaging: appEnv === 'staging',
  isProduction: appEnv === 'production',
  apiBaseUrl: trimTrailingSlash(import.meta.env.VITE_API_BASE_URL),
  uploadsBaseUrl: trimTrailingSlash(import.meta.env.VITE_UPLOADS_BASE_URL),
  siteUrl: trimTrailingSlash(import.meta.env.VITE_SITE_URL),
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
  },
};

export default env;
